/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { WsMessage } from '@shared/models/constants.model';

@Injectable({
  providedIn: 'root',
})
export class WebsocketsService {
  private static registered = false;
  private static userId = null;

  constructor(private socket: Socket) {}

  connect() {
    this.socket.connect();
    this.socket.on('reconnect', (attempt) => this.onReconnect(attempt));
  }

  registerAsUser(userId: number, ignoreRegistered = false) {
    if ((!WebsocketsService.registered || ignoreRegistered) && userId) {
      this.sendMessage(WsMessage.REGISTER, userId);
      WebsocketsService.registered = true;
      WebsocketsService.userId = userId;
    }
  }

  unregister() {
    if (WebsocketsService.registered) {
      this.sendMessage(WsMessage.UNREGISTER, null);
      WebsocketsService.registered = false;
    }
  }

  sendMessage(type: WsMessage, message: any) {
    this.socket.emit(type, message);
  }

  listen(type: WsMessage): Observable<any> {
    return this.socket.fromEvent(type);
  }

  private onReconnect(attempt) {
    if (WebsocketsService.userId) {
      this.registerAsUser(WebsocketsService.userId, true);
    }
  }
}
